module.exports = __webpack_public_path__ + "img/what-happens-desktop@2x.b1890f27.webp";